module.exports = __webpack_public_path__ + "static/fabric-table-inner-navigation-e1abb3fba098243b75eb3d5c97af89a8.gif";